import React from 'react';

import axios from 'axios';
import axiosUrl from '../../axios/url';

import InfiniteScroll from "react-infinite-scroll-component";

import DeliveryHeader from './DeliveryHeader';
import DeliveryHistory from './DeliveryHistory';


export default function Delivery(param) {

    const [projects, setProjects] = React.useState([]);
    const [selectedProject, setSelectedProject] = React.useState(0);
    const [selectedProgram, setSelectedProgram] = React.useState(0);
    const [selectedProgramName, setSelectedProgramName] = React.useState('');
    const [deliveryItems, setDeliveryItems] = React.useState([]);

    const [selectedUser, setSelectedUser] = React.useState(0);
    const [selectedUserName, setSelectedUserName] = React.useState('');

    // infinite scroll
    const [size, setSize] = React.useState(35);
    const [page, setPage] = React.useState(1);
    const [items, setItems] = React.useState([]);
    const [newItems, setNewItems] = React.useState([]);
    const [hasMoreItems, setHasMoreItems] = React.useState(true);

    const [beUserDidId, setBeUserDidId] = React.useState('');

    // handlers
    function onChangeProject(e) { 
        if(e.target.value < 0 ){
            setItems([]);
            setNewItems([]);
        }else{
            setSelectedProject(e.target.value); 
            getUserList(1, e.target.value, true);
        }
        setSelectedUser('-1'); // 비정상적인 값을 넣어서 이력목록 초기화
        setSelectedUserName('');
        setSelectedProgram(0);
        setSelectedProgramName('');

        document.getElementById('external-events').scrollTop = 0;
    }


    function onChangeProgram(id, name){
        setSelectedProgram(id);
        setSelectedProgramName(name);
    }

    // user목록 스크롤러 DB에서 값 읽어와서 추가하기
    const loadMoreItems = () => {
        if(hasMoreItems)  getUserList(page, selectedProject, false);
    };

  // 사용자 목록 조회
  async function getUserList(nextPage, projectId, isInit){
    if(projectId < 1 ) return;
    const url = axiosUrl.user_list + projectId + '/users/';
    await axios.get(url,{
        params:{
            size: size,
            page: nextPage,
            sort: 'id',
            order: 'asc'
        }
    })
    .then( response => {
        const result = response.data;
        
        if(JSON.stringify(result.data) === JSON.stringify(newItems)) return;
        
        return new Promise(resolve => {
            setTimeout(() => {
                if(result.length < size) {setHasMoreItems(false); }
                setHasMoreItems(true);
                setNewItems(result);
                setPage(nextPage+1);

                if(isInit) setItems(result);
                else setItems(items.concat(result));

                // 최초로 사용자 목록을 화면에 뿌릴때 모든 프로그램 목록 div를 hidden해야함.
                 //for(let i=0; i< result.length; i++){
                 //    const obj = document.getElementById(i);
                 //    obj.className = 'd-none';
                 //}
                
                resolve();
            }, 500);
            });
        
        
    })
    .catch(function (e) {
            console.error('[MEDIEX_CMS_2019_ERROR] Delivery.getUserList - ' + e.response.data.error.message);
    });

}

    // 프로젝트 목록 조회
    async function getProjectList(){
        var url = axiosUrl.project;
        await axios.get(url,{
            params:{
                page: '-1'
            }
        })
        .then( response => {
            if(JSON.stringify(projects) !== JSON.stringify(response.data)) { 
                setProjects(response.data) ;
                setPage(1);
                setSelectedProject(0);
            }
        })
        .catch(function (e) {
                console.error('[MEDIEX_CMS_2019_ERROR] Delivery.getProjectList - ' + e.response.data.error.message);
        });
    }

    function onClickUserName(divId, userId, userName){
        setSelectedUser(userId);
        setSelectedUserName(userName);
        setSelectedProgram(0);
        setSelectedProgramName('');

        changeDisplay(divId);
    }

    function changeDisplay(objId){
        const obj = document.getElementById(objId);
        const beObj = document.getElementById(beUserDidId);
        
        if(obj.className === 'd-none') {
            obj.className = 'd-block';
            if(beObj){
                if(objId !== beUserDidId) beObj.className = 'd-none';
            } 
        }else{
            obj.className = 'd-none';
        } 

        setBeUserDidId(objId);
    }


    React.useEffect(() => {
        getProjectList();
    },[selectedProject]);


    return(
        <div>
            <div className="content-wrapper">
            
                <DeliveryHeader/>

                <section className="content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-md-5">
                                <div className="sticky-top mb-3">
                                <div className="card">
                                        <div className="card-header  contentColor">
                                            <h4 className="card-title">프로젝트</h4>
                                        </div>
                                        
                                        <div className="card-body">
                                        <select className="form-control select2 select2-danger" defaultValue="0" data-dropdown-css-class="select2-danger" onChange={onChangeProject}>
                                            <option value="-10" >프로젝트를 선택하세요</option>
                                            {projects.map(project => (
                                                <option key={project.id} value={project.id}>{project.name}</option>
                                            ))} 
                                        </select>
                                        </div>
                                    </div>

                                    <div className="card">
                                        <div className="card-header  contentColor">
                                            <h4 className="card-title">사용자</h4>
                                        </div>
                                        
                                        {/* fixed-panel 이걸 div card-body에 추가하면 높이가 고정 됨 */}
                                        <div className="card-body">
                                            <div id="external-events" className="panel-group InfiniteList">
                                           
                                            <InfiniteScroll
                                                dataLength={items.length}
                                                next={loadMoreItems}
                                                hasMore={hasMoreItems}
                                                scrollableTarget="external-events"
                                            >
                                                
                                                {items.length <  1 && <div className="text-center">no data</div>}
                                                {items.map((item, index) => (

                                                <div className="border-light" key={index}>
                                                    
                                                    <div className="InfiniteUserList border-bottom border-dark"  onClick={() => onClickUserName(index, item.id, item.username)} >{item.username}</div>
                                                    
                                                    <div className="d-none" id={index}  >
                                                        {item.programs.map(pro => (
                                                            <div className="InfiniteProgram border" key={pro.program.id + '_' + pro.program.name} onClick={() => onChangeProgram(pro.program.id, pro.program.name)}  >
                                                                {pro.program.name}<br />
                                                                {pro.weeks}주차 , {pro.days}일째<br />({pro.startDate} ~ {pro.endDate})
                                                            </div>

                                                        ))} 
                                                    </div>
                                                </div>

                                                ))}
                                            </InfiniteScroll>

                                            </div>
                                        </div>
                                    </div>
                            
                                </div>
                            </div>
                            <DeliveryHistory projectId={selectedProject} userId={selectedUser} programId={selectedProgram} programName={selectedProgramName} userName={selectedUserName} />
                        </div>
                    </div>
                </section>

                    
            </div>

        </div>
        


    );
}